import React, { useCallback } from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import { CDN_TYPE_CRM, imageUrlCDN } from 'utils';

import { BonusCard, MoneyValue } from '@atlas/ui';

const propTypes = {
  activateBonus: func.isRequired,
  bonus: shape({
    bonusType: string,
    financeDataList: arrayOf(
      shape({
        currency: string,
        maxBonusAmount: number,
        minDeposit: number,
      }),
    ),
    imageDescription: string,
    imageLink: string,
    name: string,
    wager: number,
  }).isRequired,
  currency: string.isRequired,
  setIsOpenedDetails: func.isRequired,
};

const BonusCardWrapper = ({ activateBonus, bonus, currency, setIsOpenedDetails }) => {
  const activateBonusHandler = useCallback(() => {
    activateBonus(bonus);
  }, [bonus, activateBonus]);

  const financeData = bonus.financeDataList?.find(data => data.currency === currency);

  const onOpenDetailsHandler = useCallback(() => {
    setIsOpenedDetails(true);
  }, [setIsOpenedDetails]);

  const onHideDetailsHandler = useCallback(() => {
    setIsOpenedDetails(false);
  }, [setIsOpenedDetails]);

  return (
    <BonusCard
      className="registration-bonus-popup__card"
      image={imageUrlCDN(bonus.imageLink, CDN_TYPE_CRM)}
      imageDescription={bonus.imageDescription}
      key={bonus.name}
      maxBonus={<MoneyValue currency={financeData?.currency} value={financeData?.maxBonusAmount} />}
      minDeposit={<MoneyValue currency={financeData?.currency} value={financeData?.minDeposit} />}
      onActivate={activateBonusHandler}
      onHideDetailsClick={onHideDetailsHandler}
      onShowDetailsClick={onOpenDetailsHandler}
      title={bonus.name}
      type={bonus.bonusType}
      wager={`${bonus.wager}`}
    />
  );
};

BonusCardWrapper.propTypes = propTypes;

export default BonusCardWrapper;
